import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { searchService } from "../../services/api/search.service";
import { reportService } from "../../services/api/report.service";
import { utils } from "../../services/helpers/utils";


export const ContestationsMMResults = (props) => {

    const { partener, deladata, ladata, cnp, medic_intern, investigatie } = props.params;
    const [fise, setFise] = useState(null);
    const navigate = useNavigate();


    const params = {
        partener: partener,
        deLaData: deladata ? utils.convertDate(deladata) : null,
        laData: ladata ? utils.convertDate(ladata) : null,
        cnp: cnp,
        medic: medic_intern,
        serviciul: investigatie
    };


    useEffect(() => {
        if (partener != undefined) {

            searchService.getMMContestations(params)
                .then(response => {
                    if (response) {
                        setFise(response);
                    }
                    else {
                        setFise([]);
                    }
                });
        }

    }, [props.params]);

    const handleExport = () => {
        if (fise.length === 0) {
            alertService.error("Nu exista date pentru export!");
            return;
        }

        reportService.RaportContestatiiMM(params).then((response) => {
            if (response) {
                utils.downloadFile(response, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
                return;
            }
        });
    }

    const handleView = (page, param, value) => {

        var encode = {
            partner: partener,
            deLaData: deladata ? utils.convertDate(deladata) : null,
            laData: ladata ? utils.convertDate(ladata) : null,
            cnp: cnp,
            medic: medic_intern,
            serviciul: investigatie
        };

        var encodedString = btoa(JSON.stringify(encode));

        navigate(window.location.hash + `?q=${encodedString}`, { replace: true });
        navigate(`/dashboard/${page}?${param}=${value}`);
    }


    return (
        <>
            {fise && fise.length >= 0 &&
                <>
                    <p className="paragraf">Fise de aptitudini:</p>
                    <table className="tbl" data-name="lista_mm" width="100%">
                        <thead>
                            <tr>
                                <th className="first">Nr</th>
                                <th>Companie</th>
                                <th>Abonament</th>
                                <th>Medic intern</th>
                                <th>Data ora</th>
                                <th>Serviciul</th>
                                <th>Partener</th>
                                <th></th>
                            </tr>
                        </thead>
                    <tbody>
                        {fise.map((fisa, index) => (
                            <tr key={index}>
                                <td data-name="nr_crt" className="center">  {index + 1} </td>
                                <td data-name="nume_firma">{fisa.companie}</td>
                                <td data-name="nume_profil">
                                    {fisa.abonament}
                                    {fisa.firmaMaster && <span> (</span>}
                                    {fisa.firmaMaster}
                                    {fisa.firmaMaster && <span>)</span>}

                                </td>
                                <td data-name="nume_medic">{fisa.medic}</td>
                                <td data-name="data_ora" className="center">{fisa.dataOra}</td>
                                <td data-name="serviciul">{fisa.serviciu}</td>
                                <td data-name="partener" className="center">{fisa.partener}</td>
                                <td>
                                    <a className="icon deschide"
                                        onClick={() => handleView("fisa-mm", "id", fisa.idFisa)}
                                        title="Vezi contestatie" data-name="view">Vizualizare</a>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                    <div data-name="export">
                    <button data-name="btn-export-mm" className="btn" onClick={ handleExport }>Export</button>
                    </div>
                </>
            }
        </>
    );
};

